export class User {
  email: string;
  name: string;
  nickname: string;
  picture: string;
  attributes: Record<string, unknown>;
  authorities: string[];
  id: number | string;
  username: string;
  realm: string;
}

export class UserBaseModel {
  id: number;
  name: string;
}
